import moment from "moment";

import { Client } from "@/Common/Api/Client";
import { ExternalEmployeeResponse } from "@/Common/Api/ExternalCommunications/Dto/Responses/ExternalEmployeeResponse";
import { GridExternalMessageResponse } from "@/Common/Api/ExternalCommunications/Dto/Responses/GridExternalMessageResponse";
import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { DateSelector } from "@/Common/Components/Inputs/DateSelector";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { DateTime } from "@/Common/Helpers/DateTime";
import { PatientHistoryMessage } from "@/Common/Models/ExternalCommunications/GridExternalMessage";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { ExternalMessageViewComponent } from "@/Communications/Components/ExternalCommunications/View/ExternalMessageViewComponent";

interface IPatientHistoryExternalCommunicationsViewProps { }

class ExternalCommunicationsViewState {
    public messages: PatientHistoryMessage[];
    public selectedMessageId: string;
    public showOnlyUnread: boolean;
    public isCriteriaExpanded: boolean;
    public dateFrom: Date;
    public dateTo: Date;
    public searchText: string;
}

class ExternalCommunicationsView extends BaseReactComponent<IPatientHistoryExternalCommunicationsViewProps, ExternalCommunicationsViewState> {
    public constructor(props: IPatientHistoryExternalCommunicationsViewProps) {
        super(props);

        this.state = {
            messages: [],
            selectedMessageId: "",
            showOnlyUnread: false,
            isCriteriaExpanded: false,
            dateFrom: null,
            dateTo: null,
            searchText: ""
        };
    }

    public componentDidMount(): void {
        this.loadExternalMessages();

        $(window).trigger("resize");
    }

    public render(): JSX.Element {
        return (
            <div className="medical-summary-container">
                <div className="tb medical-summary">
                    {this.leftSide()}
                    {this.state.selectedMessageId ? this.rightSide() : this.emptyRightSide()}
                </div>
            </div>
        );
    }

    private messageList(): JSX.Element {
        let messageRender = this.state.messages.map(m => {
            let classname = m.isFailedSend ? "pointer red-text" : "pointer";
            return (
                <div className={classname} key={m.messageId} onClick={() => this.onChange(m.messageId)}>
                    <div className="med-note">
                        <div className="tb">
                            <div className="tbc">
                                <p className="ellipsis"><strong>{m.subject}</strong></p>
                                <p> {this.getFormattedSenderEmployeeName(m)}
                                </p>
                            </div>
                            <div className="tbc text-right">
                                <span className="date">{moment.utc(m.sendDate).format("YYYY/MM/DD")}</span>
                            </div>
                        </div>
                    </div>
                </div>
            );
        });

        return (
            <div data-hvar="40" className="note-collection scrollable">
                {messageRender}
            </div>
        );
    }

    private leftSide(): JSX.Element {
        let critariaText = this.state.isCriteriaExpanded ? "[-] " : "[+] ";

        let toggleIconCss = "toggle-icon2";
        if (this.state.showOnlyUnread)
            toggleIconCss += " active";

        return (
            <div className="fxheight tbc full-border left-primary">
                <div className="note-search">
                    <div className="header" />
                    <div className="search-field">
                        <div className="gf">
                            <span className="glyphicon glyphicon-search" />
                        </div>
                        <div className="pull-left">
                            <TextboxControl
                                debounceMs={400}
                                value={this.state.searchText}
                                className="fullWidth"
                                onChange={val => this.mutateState(s => s.searchText = val, () => this.loadExternalMessages())}
                                placeholder={cacheStore.GetString("SearchLabel")}
                            />
                        </div>
                    </div>
                    {this.state.isCriteriaExpanded && (
                        <div style={{ marginTop: "10px" }}>
                            <DateSelector
                                id="xcomFromDate"
                                date={this.state.dateFrom}
                                onChangeCallback={date =>
                                    this.mutateState(
                                        s => s.dateFrom = date && moment(date).startOf("day").toDate(),
                                        () => this.loadExternalMessages()
                                    )
                                }
                                dateFormat="yyyy-MM-dd"
                                width={269}
                                height={38}
                                disabled={false}
                                valid={(this.state.dateFrom && this.state.dateTo) && (moment(this.state.dateFrom) < moment(this.state.dateTo))}
                            />
                            <span>
                                <a onClick={() => this.mutateState(s => s.dateFrom = moment(DateTime.nowDeprecated()).startOf("day").toDate(), () => this.loadExternalMessages())}>
                                    {cacheStore.GetString("TodayLabel")}
                                </a>
                            </span>

                            <DateSelector
                                constainerStyle={{ marginTop: "10px" }}
                                id="xcomToDate"
                                date={this.state.dateTo}
                                onChangeCallback={date =>
                                    this.mutateState(
                                        s => s.dateTo = date && moment(date).endOf("day").toDate(),
                                        () => this.loadExternalMessages()
                                    )
                                }
                                dateFormat="yyyy-MM-dd"
                                width={269}
                                height={38}
                                disabled={false}
                                valid={(this.state.dateFrom && this.state.dateTo) && (moment(this.state.dateTo) > moment(this.state.dateFrom))}
                            />
                            <span>
                                <a onClick={() => this.mutateState(s => s.dateTo = moment(DateTime.nowDeprecated()).endOf("day").toDate(), () => this.loadExternalMessages())}>
                                    {cacheStore.GetString("TodayLabel")}
                                </a>
                            </span>

                        </div>
                    )}
                    <div className="clearfix" style={{ marginTop: "15px" }}>
                        <span
                            style={{ marginRight: "7px" }}
                            className={toggleIconCss}
                            onClick={() => this.mutateState(s => s.showOnlyUnread = !s.showOnlyUnread, () => this.loadExternalMessages())}
                        />
                        <a
                            className="pull-right"
                            onClick={() => this.mutateState(s => s.isCriteriaExpanded = !s.isCriteriaExpanded)}
                        >
                            {critariaText + cacheStore.GetString("CriteriaLabel")}
                        </a>
                    </div>
                </div>
                {this.messageList()}

            </div>
        );
    }

    private rightSide(): JSX.Element {
        return (
            <ExternalMessageViewComponent
                title={cacheStore.GetString("MessageDetailsLabel")}
                messageId={this.state.selectedMessageId}
                showSharedViewers={true}
            />
        );
    }

    private emptyRightSide(): JSX.Element {
        return (
            <div className="tbc right-primary">
                <div className="scrollable">
                    <div className="summary-container no-border" />
                </div>
            </div>
        );
    }

    private getFormattedSenderEmployeeName(message: PatientHistoryMessage): string {
        if (message.senderInternalEmployeeId) {
            let employee = cacheStore.GetEmployeeByContactFacetId(message.senderInternalEmployeeId);

            return ExternalEmployeeResponse.buildDisplayName(
                employee.FirstName,
                employee.LastName,
                employee.PrefixLookupId
            );
        }

        return ExternalEmployeeResponse.buildDisplayName(
            message.senderExternalEmployeeFirstName,
            message.senderExternalEmployeeLastName,
            message.senderExternalEmployeePrefixLookupId
        );
    }

    private onChange(id: string): void {
        this.mutateState(s => {
            s.selectedMessageId = id;
        });
    }

    private loadExternalMessages(): void {
        let requestData = {
            PatientContactFacetId: patientStore.getCurrentPatient().PatientResponse.ContactFacet_id,
            DateFrom: this.state.dateFrom,
            DateTo: this.state.dateTo,
            SearchText: this.state.searchText,
            LoadUnreadOnly: this.state.showOnlyUnread
        };

        Client.Postv2(
            ServerOperations.Server.Myle_ExternalCommunication_LoadPatientMessages,
            requestData,
            response => {
                if (response) {
                    let externalMessageResponse: GridExternalMessageResponse[] = response.Messages;

                    this.mutateState(s => {
                        s.messages = externalMessageResponse.map(x => new PatientHistoryMessage(x));
                    });
                }
            }
        );
    }
}

export { ExternalCommunicationsView };
